import $ from "jquery";
import moment from 'moment';
import DataTable from "datatables.net-bs5";
import {getDataTableName, getDataTableOptions} from "@/helpers/datatable/datatable-helper";
import Editor from "datatables.net-editor";
// import "datatables.net-editor-bs5";
import {initPopper} from "@/modules/popper";
import {reloadServiceClick} from "@/helpers/ol/ol-http-helper";
import 'datatables.net-datetime';
import select2 from 'select2';
import '@/select2plugin';
import '@/miniColorsPlugin';
import {loadLinkedData} from "@/helpers/layer/info/layer-info-info-linked-data-helper";
import {getDataTableEditorFields} from "@/helpers/datatable/datatable-editor-field-helper";
import {getToken} from "@/helpers/auth/auth-helper";
import toastr from "toastr"
import {initDataTableEditorEvents} from "@/helpers/datatable/datatable-editor-event-helper";
import {
    getLayerByName,
    getProjectionByBookmarkPresentationID,
    refreshAllActiveLayers,
    removeLayer
} from "@/helpers/ol/ol-layer-helper";
import {
    getActiveMutation,
    getMutationFeatureInfo,
    getMutationLayerName,
    inactiveMutationGeometryButton,
    setActiveMutation
} from "@/helpers/tools/tools-mutation-helper";
import {showElementsBySelector} from "@/helpers/element-helper";
import {generateGeoJsonObjectFromFeature} from "@/helpers/ol/ol-geo-json-helper";
import {disableMoveLayer, moveLayer} from "@/helpers/ol/map/ol-move-helper";
import {
    generateDataTableItem,
    generateDataTableMutationAttributes
} from "@/components/layer/info/info/layer-info-info-item-component";
import {initDataTableStandAloneEditor} from "@/helpers/datatable/datatable-standalone-editor-helper";
import {setDrawGeometry} from "@/helpers/ol/draw/ol-draw-polygon-helper";
import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper.js";

select2($);

let hiddenColumns
let dynamicSelect = []

export function initDataTableEditor(dataTable) {

   dynamicSelect = []
   window.moment = moment

    hiddenColumns = []
    const name = getDataTableName(dataTable)
    const featureInfo = dataTable.featureInfo

    const editorOptions = getDataTableEditorOptions(dataTable, name)
    const editor = initEditor(dataTable, name, editorOptions)
    const options = getDataTableOptions( dataTable, name)

    options.buttons = []
    if(featureInfo.UserRights.includes(7)) {
        options.buttons.push({
            extend: "create",
            text: '<span class="fa fa-plus"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Toevoegen<div class="arrow" data-popper-arrow=""></div></div>',
            editor: editor,
            formButtons: getDataTableEditorFormButtons(),
            className: 'btn-outline-secondary icon-btn btn-sm popper-header'
        })
    }
    if(featureInfo.UserRights.includes(3)) {
        options.buttons.push({
            extend: "edit",
            text: '<span class="fa fa-edit"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Bewerken<div class="arrow" data-popper-arrow=""></div></div>',
            editor: editor,
            formButtons: getDataTableEditorFormButtons('edit'),
            // formMessage: function ( e, dt ) {
            //     return 'Velden met * zijn verplicht'
            // },
            className: 'btn-outline-secondary icon-btn btn-sm ml-1 popper-header'
        },)
    }
    if(featureInfo.UserRights.includes(8)) {
        options.buttons.push({
            extend: "remove",
            text: '<span class="fa fa-trash"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Verwijderen<div class="arrow" data-popper-arrow=""></div></div>',
            editor: editor,
            formButtons: getDataTableEditorFormButtons('remove'),
            className: 'btn-outline-secondary icon-btn btn-sm ml-1 popper-header'
        })
    }

    if(hiddenColumns.length > 0) {
        options.columnDefs.push(...hiddenColumns)
    }

    // Batch mutation
    if(featureInfo.FormType === 17) {
        options.select = true
        options.buttons.push(
            {
                extend: 'selectNone',
                text: '<span class="fa fa-check"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Deselecteer alle objecten<div class="arrow" data-popper-arrow=""></div></div>',
                className: 'btn-outline-secondary icon-btn btn-sm ml-1 popper-header',
            },
            {
                extend: 'selectAll',
                text: '<span class="fa fa-check-double"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Selecteer alle objecten<div class="arrow" data-popper-arrow=""></div></div>',
                className: 'btn-outline-secondary icon-btn btn-sm ml-1 popper-header',
            }
        );
    }

    // console.log(options)

    if(dataTable.featureInfo.IsShowMoreInfoVisible) {
        options.buttons.push(
            {
                extend: "selectedSingle",
                editor: editor,
                text: '<span class="fa fa-info"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Meer informatie<div class="arrow" data-popper-arrow=""></div></div>',
                className: 'btn-outline-secondary icon-btn btn-sm ml-1 popper-header',
                action: function ( e, dt, node, config ) {
                    const data = $('#' + name).DataTable().row( { selected: true } ).data();
                    loadLinkedData(dataTable.DomainID, dataTable.PresentationID, data.featureid, dataTable.index)
                }
            }
        )
    }

    const table = new DataTable( '#' + name, options);

    table.buttons().container().appendTo( $(`.accordion-header[data-presentation-id="${dataTable.PresentationID}"][data-form-id="${dataTable.FormID}"][data-feature-index="${dataTable.FeatureIndex}"]`).parent() );

    // console.log(dataTable)

    const geoJson = generateGeoJsonObjectFromFeature(dataTable.feature, false)

    let geometry = undefined
    if(geoJson.length > 0) {
        geometry = geoJson[0].getGeometry()
    }

    initDataTableEditorEvents(dataTable, editor, editorOptions, undefined, table, geometry)

    initPopper()

    return {
        editor: editor,
        url: editorOptions.ajax.create.url
    }
}

export function initEditor(dataTable, name, editorOptions) {
    Editor.bootstrap( bootstrap );

    window.moment = moment
    /**
     * Change the default classes from Editor to be classes for Bootstrap
     */
    $.extend( true, $.fn.dataTable.Editor.classes, {
        "Action_Create": {
            "wrapper": "modal-content"
        },
        "header": {
            "wrapper": " modal-header"
        },
        "body": {
            "wrapper": " modal-body"
        },
        "footer": {
            "wrapper": " modal-footer"
        },
        "form": {
            "tag": "form-horizontal",
            "button": "btn",
            "buttonInternal": "btn btn-outline-secondary"
        },
        "field": {
            "wrapper": "form-group row",
            "label":   "col-lg-4 col-form-label",
            "input":   "col-lg-8",
            "error":   "error is-invalid",
            "msg-labelInfo": "form-text text-secondary small",
            "msg-info":      "form-text text-secondary small",
            "msg-message":   "form-text text-secondary small",
            "msg-error":     "form-text text-danger small",
            "multiValue":    "card multi-value",
            "multiInfo":     "small",
            "multiRestore":  "multi-restore"
        }
    } );

    return new Editor(editorOptions);
}

export function createElementFromHTML(htmlString) {
    if(!htmlString) {
        return ''
    }
    const div = document.createElement('div');
    div.innerHTML = String(htmlString).trim();

    return div.firstChild;
}

export function getDataTableEditorAjaxSettings(url, token, featureID) {
    return {
        create: {
            type: 'POST',
                data: function (d) {
                // myHeaders.append("Authorization", token);
                d.csrf_name = $('meta[name="csrf-token-name"]').attr('content')
                d.csrf_value = $('meta[name="csrf-token-value"]').attr('content')
            },
            url: url,
                headers: {
                "Authorization": token
            },
            error: function(xhr, error, code) {
                if (xhr.status === 403) {
                    console.log("403 error")
                } else {
                    console.log("andere error")
                }

                return false;
            }
        },
        edit: {
            type: 'PUT',
                data: function (d) {
                d.csrf_name = $('meta[name="csrf-token-name"]').attr('content')
                d.csrf_value = $('meta[name="csrf-token-value"]').attr('content')

                if(d.data.keyless) {
                    d.featureid = featureID
                }
            },
            url: url,
                headers: {
                "Authorization": token
            }
        },
        remove: {
            type: 'DELETE',
                data: function (d) {

                let featureID
                for (const item in d.data) {
                    featureID = item
                }

                d.csrf_name = $('meta[name="csrf-token-name"]').attr('content')
                d.csrf_value = $('meta[name="csrf-token-value"]').attr('content')
                if(featureID) {
                    d.data[featureID] = {featureID: featureID}
                }
            },
            url: url,
                headers: {
                "Authorization": token
            }
        }
    }
}

export function getDataTableEditorOptions(dataTable, name = null, isStandAlone = false, featureID = null) {
    const dataTableEditorFields = getDataTableEditorFields(dataTable, hiddenColumns, isStandAlone)
    const fields = dataTableEditorFields.fields

    //// console.log(fields)

    hiddenColumns = dataTableEditorFields.hiddenColumns

    const url = window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/domain/' + dataTable.DomainID + '/presentation/' + dataTable.PresentationID + '/mutation/' + dataTable.FormID;

    const token = getToken()
    const editor = {
        ajax: getDataTableEditorAjaxSettings(url, token, featureID),
        idSrc: 'featureid',
        fields: fields,
        i18n: {
            "create": {
                "button": "Toevoegen",
                "title": "Object toevoegen",
                "submit": "Opslaan"
            },

            "edit": {
                "button": "Bewerk",
                "title": "Object bewerken",
                "submit": "Opslaan"
            },
            "remove": {
                "button": "Verwijderen",
                "title": "Object verwijderen",
                "submit": "Verwijderen",
                "confirm": {
                    "_": "Weet je zeker dat je %d objecten wilt verwijderen?",
                    "1": "Weet je zeker dat je 1 object wilt verwijderen?"
                }
            },
            "error": {
                "system": "A system error has occurred (More information)"
            },
            "multi": {
                "title": "Meerdere waarden",
                "info": "De geselecteerde items bevatten verschillende waarden voor deze invoer. Klik of tik hier om alle items voor deze invoer te bewerken en in te stellen op dezelfde waarde, anders behouden ze hun individuele waarden.",
                "restore": "Veranderingen terugdraaien",
                "noMulti": "Deze invoer kan afzonderlijk worden bewerkt, maar maakt geen deel uit van een groep."
            },
            "datetime": {
                "previous": 'Vorige',
                "next": 'Volgende',
                "months": ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
                "weekdays": ['Zon', 'Man', 'Din', 'Woe', 'Don', 'Fri', 'Zat'],
                "amPm": ['am', 'pm'],
                "unknown": '-'
            }
        },
        formOptions: {
            main: {
                // onEsc: false,
                focus: null
            }
        }
    }

    if(name) {
        editor.table = '#' + name
    }

    editor.dynamicFields = dataTableEditorFields.dynamicFields

    return editor
}

export function getDataTableEditorFormButtons(type = 'create', isStandAlone = false, isLinked = false) {

    let label = ''
    let labelClass = 'btn-success'
    switch (type) {
        case 'create':
            label = '<span class="fa fa-plus"></span> Opslaan'
            break;
        case 'edit':
            label = '<span class="fa fa-edit"></span> Opslaan'
            break;
        case 'remove':
            label = '<span class="fa fa-trash"></span> Verwijderen'
            labelClass = 'btn-danger'
            break;
    }

    window.closeType = 'escape'

    const editorButtons = [
        {
            label: label,
            fn: function () {
                this.submit(
                    function (result) {

                        window.closeType = 'submit'

                        if(result.scriptResult) {
                            toastr[result.scriptResult.type](result.scriptResult.message, result.scriptResult.title);
                        }

                        if(isStandAlone) {
                        } else {
                            reloadServiceClick()
                        }
                    }
                );
            },
            className: labelClass + ' float-right'
        },
        {
            label: "Annuleren",
            fn: function () {

                window.closeType = 'cancel'

                removeLayer(getMutationLayerName(), false)
                disableMoveLayer()
                refreshAllActiveLayers()

                this.close();
            },
            className: 'btn-outline-secondary'
        },
        {
            label: "Herstellen",
            fn: function () {

                window.closeType = 'recover'

                const result = moveLayer(getMutationLayerName(), undefined, 'edit', false)
                if(!result) {
                    showElementsBySelector('layer-info-info-mutation-standalone-edit-geometry-save')
                    showElementsBySelector('layer-info-info-mutation-standalone-edit-geometry-cancel')
                }

                this.close();
            },
            className: 'btn-warning'
        }
    ]

    if(type === 'create' && isStandAlone && !isLinked) {
        editorButtons.push({
            label: 'Opslaan + nieuwe toevoegen',
            fn: function () {
                this.submit(
                    function (result) {

                        window.closeType = 'cancel'

                        if(result.scriptResult) {
                            toastr[result.scriptResult.type](result.scriptResult.message, result.scriptResult.title);
                        }

                        const activeMutation = getActiveMutation()
                        setActiveMutation(activeMutation.featureInfo.BookmarkPresentationID, activeMutation.featureInfo.DomainID, activeMutation.featureInfo.PresentationID, activeMutation.featureInfo.FormID)
                    }
                );
            },
            className: labelClass + ' float-right'
        })
    }

    return editorButtons
}

export function finishMutationDrawing(feature = null) {

    const featureInfo = getMutationFeatureInfo()
    if(!feature) {
        feature = getLayerByName(getMutationLayerName(), false).getSource().getFeatures()[0]
    }

    const projection = getProjectionByBookmarkPresentationID(featureInfo.BookmarkPresentationID)

    setDrawGeometry(feature, getViewProjectionName(), projection)

    let dataTableItem = generateDataTableItem(featureInfo, 0, 0, 0, featureInfo.BookmarkPresentationID, feature)
    dataTableItem = generateDataTableMutationAttributes(dataTableItem, featureInfo)
    initDataTableStandAloneEditor(dataTableItem, 'create')
    inactiveMutationGeometryButton()
}

export function updateEditorTokens() {
    $.ajaxSetup({
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', getToken());
        }
    });
}
